import { Injectable, inject } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, from, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { buildAuthenticatedHubConnection } from './signalr-connection.utils';
import { UserLoginService } from './user-login.service';

@Injectable({
  providedIn: 'root',
})
export class SignalrPresenceService {
  private userService = inject(UserLoginService);

  private presenceConnection: signalR.HubConnection;

  private presenceHub: string = `/presence`;

  private presence = new BehaviorSubject<PresenceResponse>([null, []]);

  private isConnected = false;

  public connectPresencesHub() {
    return this.userService.auth.getAccessTokenSilently({ detailedResponse: true }).pipe(
      switchMap(async (token) => {
        const idToken = token.access_token;
        try {
          this.presenceConnection = buildAuthenticatedHubConnection(this.presenceHub, idToken);

          await this.presenceConnection.start();
          this.isConnected = true;

          this.presenceConnection.on('ReceivePresence', (data, moredata) => {
            this.presence.next([data, moredata]);
          });

          console.log(`SignalR connection success! connectionId: ${this.presenceConnection.connectionId}`);
        } catch (error) {
          console.log(`SignalR connection error: ${error}`);
        }
      }),
    );
  }
  public joinRoom(roomName: string) {
    return from(this.presenceConnection.send('JoinRoom', roomName)).pipe(
      switchMap(() => {
        return interval(5000);
      }),
      switchMap(() => {
        return from(this.presenceConnection.send('Ping', roomName));
      }),
      switchMap(() => {
        return this.presence;
      }),
    );
  }

  public leaveRoom(roomName: string) {
    if (this.isConnected) {
      this.presenceConnection.send('LeaveRoom', roomName);
    }
  }
}

export type PresenceResponse = [string | null, string[]];
